import SEOHead from "@/components/feature/SEOHead";
import Breadcrumb from "@/components/feature/Breadcrumb";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Formulaire from "./components/Formulaire";
import Carte from "./components/Carte";
import Footer from "./components/Footer";
import FloatingButton from "./components/FloatingButton";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-background-50 font-sans">
      <SEOHead
        title="Contact Dépan'Volets Strasbourg | Devis Gratuit 24h"
        description="Contactez Dépan'Volets pour toute réparation, motorisation ou pose de volet roulant à Strasbourg et dans le Bas-Rhin. Devis gratuit, intervention rapide. 03 74 47 32 40."
        path="/contact"
        type="website"
        breadcrumbs={[{ label: "Accueil", href: "/" }, { label: "Contact" }]}
      />
      <Navbar />
      <Breadcrumb items={[{ label: "Accueil", href: "/" }, { label: "Contact" }]} />
      <main>
        <Hero />
        <Formulaire />
        <Carte />
      </main>
      <Footer />
      <FloatingButton />
    </div>
  );
}